import { Button, DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutMapBrokerageCodeList extends Layout {
    buttonFindErrors: Button;
    layoutheaderMapBrokCodeList: LayoutHeader;
    sourceMapBrokerageCode: DataSource;
    tableMapBrokerageCode: Table;
}
